<template>
    <section class="friend_section flex">

        <transition name="loading-fade">
            <FriendLoading v-if="authStatus == 'loading'" />
        </transition>

        <FriendTokenError v-if="authStatus == 'error'" />
        <FriendWrap v-if="authStatus == 'success'" />


    </section>
</template>

<script>
import FriendTokenError from "../components/new/friendTokenError"

import FriendWrap from "../components/new/friendWrap"
import FriendLoading from "../components/new/friendLoading"

export default {
    name: 'FriendNew',
    components: {
        FriendTokenError,
        FriendWrap,
        FriendLoading
    },
    data(){
        return {}
    },
    computed: {
        authStatus(){
            return this.$store.state.FriendStore.status
        }
    },
    beforeCreate(){
        this.$store.dispatch('FriendStore/login', this.$route.params.friendToken)
    },
    methods: {

    }
}

</script>

<style lang="scss">
    .friend_section{
        background: $white;
    }
</style>
